<template>
<h1>DC4DIYs Wetter</h1>
<h2>Warte auf Daten</h2>
<br>
Werte werden nach und nach angezeigt wenn diese eintreffen.
<br>
<div class="spinner"></div>
</template>

<script>
export default {
  name: 'WetterOffline'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.loader-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: white;
}

.spinner {
  width: 200px;
  height: 200px;
  border: 6px solid #ccc;
  border-top: 6px solid #42b983; /* Vue-Grün oder andere Farbe */
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
